import Head from 'next/head';
import { Container, Link, Table, Tbody, Tr, Td, TableContainer, Heading } from '@chakra-ui/react';

export default function tos() {
  return (
    <>
      <Head>
        <title>特定商取引法に基づく表記</title>
      </Head>
      <Container maxW={'container.xl'} p={10} bg={'white'}>
        <Heading mb={12}>特定商取引法に基づく表記</Heading>
        <TableContainer>
          <Table variant="simple" size={'sm'}>
            <Tbody>
              <Tr>
                <Td fontWeight={'bold'}>運営事業者名</Td>
                <Td>株式会社デジタルレシピ</Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>運営事業者所在地</Td>
                <Td>〒151-0051　東京都渋谷区千駄ヶ谷5-16-11ルティアオフィス代々木 7階</Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>サービス名称</Td>
                <Td>
                  Catchy (
                  <Link
                    color={'blue.600'}
                    href="https://lp.ai-copywriter.jp/"
                    target="_blank"
                    textDecoration={'underline'}
                  >
                    https://lp.ai-copywriter.jp/
                  </Link>
                  )
                </Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>運営統括責任者</Td>
                <Td>代表取締役　伊藤　新之介</Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>お問合せ先</Td>
                <Td>
                  お問い合わせフォーム：
                  <Link
                    color={'blue.600'}
                    href="https://docs.google.com/forms/d/e/1FAIpQLSe2mO8wzJNn-ycv4amlqC0AIYz8ZtEHjsCSYIl6iFFgVn3BEQ/viewform"
                    target="_blank"
                    textDecoration={'underline'}
                  >
                    https://docs.google.com/forms/d/e/1FAIpQLSe2mO8wzJNn-ycv4amlqC0AIYz8ZtEHjsCSYIl6iFFgVn3BEQ/viewform
                  </Link>
                  <br />
                  ※お取引やサービスについてのお問い合わせはお電話では受け付けておりません。お問い合わせについては上記お問い合わせフォームよりご連絡をいただきますようお願い申し上げます。
                </Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>販売価格</Td>
                <Td>本ウェブサイト上で各サービスに表記された価格に準じます</Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>販売価格以外に必要となる費用</Td>
                <Td>
                  消費税
                  <br />
                  インターネット接続料金その他の電気通信回線の通信に関する費用（金額はお客様が契約されている通信事業者等が定めるとおり）
                </Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>お支払い方法・支払時期</Td>
                <Td>クレジットカード決済のみ（即日の決済となります）</Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>商品の引き渡し時期</Td>
                <Td>決済後、直ちにサービスの利用を開始できます。</Td>
              </Tr>
              <Tr>
                <Td fontWeight={'bold'}>キャンセルについて</Td>
                <Td>本サービスの特性上、お客様のご都合による利用料の返金には応じかねます。</Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
}
